import { render } from "./SelectMobileAlternatives.vue?vue&type=template&id=4289807a"
import script from "./SelectMobileAlternatives.vue?vue&type=script&lang=js"
export * from "./SelectMobileAlternatives.vue?vue&type=script&lang=js"
script.render = render

export default script